import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDot } from '#pplx/frontend/aether/components/AlertDot/index.js';
import { automationUnreadStatusMessage } from '#pplx/frontend/apps/ask/automations-shared/automationActionMessages.js';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
// Blue dot marking an unread automation/run, paired with a visually-hidden localized label for screen readers.
export function AutomationUnreadIndicator({ className, size = 'md', }) {
    return (_jsxs("span", { className: cn('flex size-4 flex-none items-center justify-center', className), children: [_jsx(AlertDot, { size: size }), _jsx("span", { className: "sr-only", children: _jsx(FormattedMessage, { ...automationUnreadStatusMessage }) })] }));
}
//# sourceMappingURL=AutomationUnreadIndicator.js.map